import { useState } from "react";
import { AppDialog } from "../../../../../common/components/AppDialog/AppDialog";
import {
  IfFalse,
  IfTrue,
  RenderWhen,
} from "../../../../../common/infrastructure/components/RenderWhen";
import { Icon, IconType } from "../../../../../common/icons/Icon";
import { FormSubmissionDialog } from "../../../../../common/preReservationForms/FormSubmissionDialog";
import { useUserFormsDialog } from "../hooks/useUserFormsDialog";
import { IUserModel } from "../models/userModel";
import { SendClientFormDialog } from "./SendClientFormDialog";
import styles from "./UserFormsDialog.module.scss";

interface IUserFormsDialogProps {
  visible: boolean;
  onHide: () => void;
  user?: IUserModel;
}

/**
 * The client's "Форми": a card that sends a form by email on top, then every form they
 * filled in, each opening its stored snapshot.
 */
export const UserFormsDialog = ({ visible, onHide, user }: IUserFormsDialogProps) => {
  const [showSendDialog, setShowSendDialog] = useState(false);
  const {
    rows,
    isLoading,
    openedHtml,
    openedFormName,
    isOpenedVisible,
    openForm,
    closeForm,
  } = useUserFormsDialog({ userId: user?.id, visible });

  return (
    <AppDialog header="Форми" visible={visible} className={styles.dialog} onHide={onHide}>
      <button type="button" className={styles.send} onClick={() => setShowSendDialog(true)}>
        <span className={styles.send_icon}>
          <Icon type={IconType.SendIcon} color="rgba(255, 255, 255, 0.95)" width="22px" height="22px" />
        </span>
        <span className={styles.send_text}>
          <span className={styles.send_title}>Изпрати форма</span>
          <span className={styles.send_hint}>Клиентът ще получи имейл с линк за попълване на формата</span>
        </span>
        <span className={styles.send_chevron} aria-hidden>
          ›
        </span>
      </button>

      <div className={styles.section_label}>Попълнени</div>

      <div className={styles.list}>
        <RenderWhen condition={!isLoading && rows.length === 0}>
          <IfTrue>
            <div className={styles.empty}>Клиентът все още няма попълнени форми.</div>
          </IfTrue>
          <IfFalse>
            {rows.map((row) => (
              <button
                type="button"
                key={row.id}
                className={styles.row}
                onClick={() => openForm(row.id)}
              >
                <span className={styles.row_top}>
                  <span className={styles.row_name}>{row.formName}</span>
                  <span className={styles.row_date}>{row.filledOnText}</span>
                </span>
                <span className={styles.row_event}>{row.eventText}</span>
              </button>
            ))}
          </IfFalse>
        </RenderWhen>
      </div>

      <FormSubmissionDialog
        visible={isOpenedVisible}
        onHide={closeForm}
        header={openedFormName || "Попълнена форма"}
        renderedHtml={openedHtml}
      />

      <SendClientFormDialog
        visible={showSendDialog}
        onHide={() => setShowSendDialog(false)}
        user={user}
      />
    </AppDialog>
  );
};
